import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function LibraryTabs() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const tabs = [
        { to: "/biblioteca", key: "recommendations", testId: "library-tab-recs" },
        { to: "/leidos", key: "read", testId: "library-tab-read" },
    ];
    return (
        <div
            data-testid="library-tabs"
            className="flex items-center gap-6 border-b border-[var(--border)] mb-10"
        >
            {tabs.map((tab) => {
                const active = pathname === tab.to;
                return (
                    <Link
                        key={tab.to}
                        to={tab.to}
                        data-testid={tab.testId}
                        aria-current={active ? "page" : undefined}
                        className={`relative pb-3 text-sm uppercase tracking-widest transition-colors ${
                            active
                                ? "text-[var(--ink)]"
                                : "text-[var(--ink-muted)] hover:text-[var(--accent)]"
                        }`}
                    >
                        {t(`library_tabs.${tab.key}`)}
                        {active && (
                            <span className="absolute left-0 right-0 -bottom-px h-0.5 bg-[var(--accent)]" />
                        )}
                    </Link>
                );
            })}
        </div>
    );
}
